<template>
  <v-container>
    <v-layout>
      <v-tooltip top>
        <v-btn v-if="$store.getters.isAdmin"
               class="mr-2 mb-2"
               @click="newUser"
               color="customPurple"
               dark
               fixed
               bottom
               right
               fab
               slot="activator"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <span>Crear Cliente</span>
      </v-tooltip>
      <v-flex>
        <div>
          <v-layout>
            <v-flex xs12 sm6 offset-sm6>
              <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Buscar"
                  single-line
                  hide-details
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-dialog
          v-model="dialog"
          max-width="700px"
          persistent
          transition="dialog-bottom-transition"
          scrollable>
        <v-card tile>
          <v-toolbar card dark color="nav_background_color">
            <v-btn icon dark @click.native="dialog = false" @click="cleanData">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Crear nuevo Usuario</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-select
                      :items="this.rolesTodos"
                      v-model="userRols"
                      label="Seleccione "
                      hint="Roles del Usuario"
                      single-line
                      item-text="name"
                      item-value="id"
                      return-object
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-text-field
                      name="login"
                      label="Usuario"
                      id="login"
                      v-model="user.login"
                      :rules="[v => !!v || 'Es requerido', v => (v && v.length < 30) || 'El número de caracteres debe ser menor a 30']"
                      required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-text-field
                      name="email"
                      label="Email"
                      id="email"
                      :rules="emailRules"
                      v-model="user.email"
                      required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-text-field
                      name="nombre"
                      label="Nombres"
                      id="name"
                      :rules="[v => !!v || 'Es requerido', v => (v && v.length <= 150) || 'El número de caracteres debe ser menor a 150']"
                      v-model="user.firstName"
                      required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-text-field
                      name="apellido"
                      label="Apellido"
                      id="lastName"
                      :rules="[v => !!v || 'Es requerido', v => (v && v.length <= 150) || 'El número de caracteres debe ser menor a 150']"
                      v-model="user.lastName"
                      required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-text-field
                      name="identification"
                      label="Identificación"
                      id="identification"
                      :rules="[v => !!v || 'Es requerido']"
                      v-model="user.identification"
                      required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <div v-if="userRols!=null">
                <v-layout v-if="userRols.id=='ROLE_USER'|| userRols.id=='ROLE_FLOTA'">
                  <v-flex xs12 sm6 offset-sm1>
                    <v-text-field
                        name="telefono"
                        label="Telefono 1"
                        id="telefono"
                        :rules="[v => (v => !!v || 'Es requerido', v && v.length == 10) || 'El número de celular tiene máximo 10 dígitos']"
                        v-model="user.clientData.telefono1"
                        required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout v-if="userRols.id=='ROLE_USER'|| userRols.id=='ROLE_FLOTA'">
                  <v-flex xs12 sm6 offset-sm1>
                    <v-select
                        :items="carrier"
                        label="Operadora 1"
                        v-model="user.clientData.operadora1"
                        :rules="[v => !!v || 'Es requerido', v => (v && v.length < 250) || 'El número de caracteres debe ser menor a 250']"
                        required
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout v-if="userRols.id=='ROLE_USER'">
                  <v-flex xs12 sm6 offset-sm1>
                    <v-text-field
                        name="telefono2"
                        label="Telefono 2"
                        id="telefono2"
                        v-model="user.clientData.telefono2"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout v-if="userRols.id=='ROLE_USER'">
                  <v-flex xs12 sm6 offset-sm1>
                    <v-select
                        :items="carrier"
                        label="Operadora 2"
                        v-model="user.clientData.operadora2"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout v-if="userRols.id=='ROLE_USER'">
                  <v-flex xs12 sm6 offset-sm1>
                    <v-text-field
                        name="telefono3"
                        label="Telefono 3"
                        id="telefono3"
                        v-model="user.clientData.telefono3"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout v-if="userRols.id=='ROLE_USER'">
                  <v-flex xs12 sm6 offset-sm1>
                    <v-select
                        :items="carrier"
                        label="Operadora 3"
                        v-model="user.clientData.operadora3"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout v-if="userRols.id=='ROLE_USER'">
                  <v-flex xs12 sm6 offset-sm1>
                    <v-text-field
                        name="telefono4"
                        label="Telefono 4"
                        id="telefono4"
                        v-model="user.clientData.telefono4"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout v-if="userRols.id=='ROLE_USER'">
                  <v-flex xs12 sm6 offset-sm1>
                    <v-select
                        :items="carrier"
                        label="Operadora 4"
                        v-model="user.clientData.operadora4"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout v-if="userRols.id=='ROLE_USER' || userRols.id=='ROLE_FLOTA'">
                  <v-flex xs12 sm10 offset-sm1>
                    <v-text-field
                        name="direccion"
                        label="Dirección"
                        id="direccion"
                        v-model="user.clientData.direccion"
                        :rules="[v => !!v || 'Es requerido', v => (v && v.length < 500) || 'El número de caracteres debe ser menor a 500']"
                        required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs12 sm6 offset-sm1>
                    <v-select
                        :items="generos"
                        label="Género"
                        v-model="user.clientData.genero"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs12 sm10 offset-sm1>
                      <v-switch
                      :label="user.activated?'Activo':'Inactivo'"
                      v-model="user.activated"
                  ></v-switch>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs12 sm10 offset-sm1>
                    <v-autocomplete
                        :items="clients"
                        v-model="userChild"
                        @change="addUserChildren"
                        label="Usuarios Hijos"
                        item-text="fullName"
                        item-value="id"
                        return-object
                    ></v-autocomplete>
                    <br>
                    <div v-for="item in this.user.clientData.userChildren">
                      <div v-if="item != null">
                        <img :src="item.image" width="40px">
                        {{item.fullName}}
                        <v-btn class="btn-rounded" small
                               @click="deleteUserChildren(item)" color="primary">Eliminar
                        </v-btn>
                      </div>

                    </div>
                  </v-flex>
                </v-layout>
                <v-layout v-if="userRols.id!='ROLE_USER' && userRols.id!='ROLE_ADMIN'">
                <v-flex xs12 sm10 offset-sm1>
                  <v-autocomplete
                      :items="this.devices"
                      v-model="device"
                      label="Seleccione un dispositivo "
                      hint="Dispositivo"
                      @change="addDevice"
                      single-line
                      item-text="completeNameDevice"
                      return-object
                  ></v-autocomplete>
                  <br>
                  <div v-for="item in this.user.clientData.devices">
                    <div v-if="item">
                    <img :src="item.image" width="40px" v-if="item.image">
                    {{item.name}}
                    <v-btn class="btn-rounded" small
                           @click="deleteDevice(item)" color="primary">Eliminar Dispositivo
                    </v-btn>
                  </div>
                  </div>
                </v-flex>
                </v-layout>

              </div>
              <v-layout>
                <v-flex xs12 sm6 offset-sm4>
                  <div>
                    <v-btn class="btn-rounded" :disabled="!valid"
                           @click="saveData" large color="primary">Guardar
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
    </v-layout>
    <h3 class="primary--text">Lista de usuarios</h3>
    <v-data-table
        :headers="headers"
        :items="this.users"
        class="elevation-1"
        sort-icon="mdi-menu-down"
        :search="search"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.firstName }}</td>
        <td class="text-xs-left">{{ props.item.lastName }}</td>
        <td class="text-xs-left">{{ props.item.login }}</td>
        <td class="text-xs-left">{{ props.item.email }}</td>
        <td class="text-xs-left">{{ props.item.activated ? "Activo" : "Inactivo" }}</td>
        <td>
          <v-tooltip top>
            <v-btn
                fab dark
                small @click="getDevices(props.item)"
                slot="activator"
                color="primary">
              <v-icon dark>gps_fixed</v-icon>
            </v-btn>
            <span>Dispositivos</span>
          </v-tooltip>
        </td>
        <td class="text-xs-left">{{ props.item.roles }}</td>
        <td>
          <v-tooltip top>
            <v-btn fab small @click="editItem(props.item)" slot="activator" color="white">
              <img src="../../assets/Editar fondo.png" width="40px"/>
            </v-btn>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip top v-if="!isMobile()">
            <v-btn fab small @click="deleteItem(props.item)" slot="activator" color="white">
              <img src="../../assets/Eliminar fondo.png" width="40px"/>
            </v-btn>
            <span>Eliminar</span>
          </v-tooltip>


          <v-tooltip top v-if="!isMobile()">
            <v-btn fab dark small @click="openDialogPassword(props.item)" slot="activator" color="primary">
              <v-icon dark>lock</v-icon>
            </v-btn>
            <span>Cambiar Contraseña</span>
          </v-tooltip>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        No se han encontrado resultados para "{{ search }}".
      </v-alert>
    </v-data-table>
    <!-- Dialog Password -->
    <v-dialog v-model="dialogPassword" max-width="500px">
      <v-card>
        <v-card-title>
          <span>Cambiar Contraseña</span>

          <v-form v-model="valid">
            Ingrese su nueva contraseña y la confirmación de la misma
            <v-text-field prepend-icon="lock" :rules="newPasswordRules" name="Nueva Contraseña"
                          label="Nueva Contraseña" type="password"
                          v-model="newPassword"></v-text-field>
            <v-text-field prepend-icon="lock" :rules="newPasswordRules"
                          name="Confirme su Nueva Contraseña" label="Confirme su Nueva Contraseña"
                          type="password" v-model="newPasswordConfirmation"
                          v-on:keyup.enter="changePassword"></v-text-field>
          </v-form>
        </v-card-title>
        <v-card-actions>
          <v-btn color="primary" flat :disabled="!valid" @click="changePassword">Cambiar</v-btn>
          <v-btn color="primary" flat @click.stop="dialogPassword=false" @click="cleanPasswordChange">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-alert v-model="alert" color="error" dismissible>
        {{error}}
      </v-alert>
    </v-dialog>
  </v-container>
</template>
<script>
import User from "../../model/User";

export default {
  data() {
    return {
      search: '',
      valid: false,
      date: '',
      menu: false,
      documentValidation: "",
      documentRules: [],
      carrier: ['Telefónica', 'Claro', 'Tuenti', 'CNT'],
      generos: ['Masculino', 'Femenino'],
      codeRules: [
        v => !!v || 'El código es requerido',
        v => (v && v.length <= 50) || 'El código debe tener menos de 50 caracteres'
      ],
      emailRules: [
        v => !!v || 'El email es requerido',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'El email debe ser valido'
      ],
      requiredField: [v => !!v || 'Es requerido'],
      dialog: false,
      headers: [
        {text: 'Nombres', value: 'firstName'},
        {text: 'Apellidos', value: 'lastName'},
        {text: 'Código de usuario', value: 'login'},
        {text: 'Email', value: 'email'},
        {text: 'Estado', value: 'activated'},
        {text: 'Dispositivos', value: 'dispositivos'},
        {text: 'Rol', value: 'authorities'},
        {text: 'Acciones', value: 'editar'},
      ],
      headers2: [
        {text: 'Avatar', value: 'avatar'},
        {text: 'Nombre del equipo', value: 'name'},
        {text: 'Acciones', value: 'name'},

      ],
      editedIndex: -1,
      user: new User(),
      userRols: [],
      users: [],
      rolesTodos: [{id: "ROLE_ADMIN", name: "Administrador del Sistema"}, {
        id: "ROLE_FLOTA",
        name: "Administrador de Flota"
      }, {id: "ROLE_INSTALADOR", name: "Instalador"}, {id: "ROLE_USER", name: "Cliente"}, {
        id: "ROLE_CHOFER",
        name: "Chofer"
      }],
      clientsImport: [],
      clientsImportDetail: [],
      device:"",
      devices:[],
      dialogPassword: false,
      newPassword: '',
      newPasswordConfirmation: '',
      newPasswordRules: [
        v => !!v || 'El password es requerido',
        v => (v && v.length <= 15 && v.length >= 8) || 'La contraseña debe ser mayor igual a 8 caracteres y menor o igual a 15 caracteres'
      ],
      alert: false,
      error: '',
      clients:[],
      client:"",
      userChildren:[],
      userChild:"",

    };
  }, methods: {
    cleanData() {
      this.$refs.form.reset()
      this.user = new User()
      this.valid = false
      this.dialog = false
      this.date = ""
    },
    newUser() {
      this.editedIndex = -1
      this.valid = false
      this.dialog = true
      this.$refs.form.reset()
      this.date = ""
      this.user = new User()
      this.user.clientData = {devices:[]}
    },
    getDevices(item) {
      this.$store.state.deviceUser = item
      this.$router.push({name: 'deviceCrud'});

    },
    saveData() {
     // if (this.validUser()) {
        if (this.$refs.form.validate()) {
          //this.userRols.push('ROLE_USER')
          this.user.clientData = JSON.stringify(this.user.clientData)
          this.user.authorities=[]
          this.user.authorities.push(this.userRols.id)
          if (this.user.id != null && this.user.id != "") {
            this.$store.dispatch('updateUser', this.user).then(response => {
              this.cleanData()
              this.reloadData()
            }, error => {
              this.$store.dispatch('createDialogError', error)
            })
          } else {
            this.$store.dispatch('addUser', this.user).then(response => {
              this.cleanData()
              this.reloadData()
            }, error => {
              this.$store.dispatch('createDialogError', error)
            })
          }
          this.dialog = false
      //  }
      }
    },
    editItem(item) {
      this.editedIndex = this.users.indexOf(item)
      let userFromList = Object.assign({}, item)
      this.$store.dispatch('getOneUser', userFromList.login).then(response => {
          response.data.fullName = response.data.identification +" - "+response.data.firstName+" "+response.data.lastName
          if (response.data.clientData != null && response.data.clientData != '') {
            response.data.clientData = JSON.parse(response.data.clientData)
            if(response.data.clientData!=null && (response.data.clientData.genero=='' || response.data.clientData.genero==null)){
              response.data.clientData.genero='Masculino'
            }
          }else{
            response.data.clientData={}
            response.data.clientData.genero='Masculino'
          }
        this.user = response.data
        
        this.userRols = {id: this.user.authorities[0], name: "Administrador del Sistema"}
        if (this.user.clientData == null || this.user.clientData=={} || this.user.clientData=="") {
          this.user.clientData = {}
          this.user.clientData.devices=[]
          this.user.clientData.userChildren=[]
          this.user.clientData.genero='Masculino'
        }
        this.dialog = true
      })

    },
    deleteItem(item) {
      this.editedIndex = this.$store.state.users.indexOf(item)
      this.user = Object.assign({}, item)
      confirm('¿Está seguro que quiere eliminar el registro?')
      && this.$store.dispatch('deleteUser', this.user.login)
          .then(response => {
          })
          .catch(error => {
            alert('El usuario selecionado tiene dispositivos asignados, elimínelos antes de realizar esta acción.');
          })
          .finally(() => {
            this.reloadData();
          })

    },
    validUser() {
      if (this.$store.state.users == null) {
        return false
      }
      for (var i = 0; i < this.$store.state.users.length; i++) {
        if (this.$store.state.users[i].login == this.user.email) {
          this.$store.state.dialogErrorMessage = "Usuario ya registrado en el sistema, intente con otro email"
          this.$store.state.progress = false
          this.$store.state.dialogError = true
          return false
        }
        if (this.$store.state.users[i].identification == this.user.identification) {
          this.$store.state.dialogErrorMessage = "Usuario ya registrado en el sistema, intente con otra identificación"
          this.$store.state.progress = false
          this.$store.state.dialogError = true
          return false
        }
      }
      return true
    },
    reloadData() {
      this.$store.state.deviceUser = ''
      this.users = []
      this.$store.dispatch('getUsersClient').then(response => {
        for (let i = 0; i < response.data.length; i++) {
          response.data[i].fullName = response.data[i].login +" - "+response.data[i].firstName+" "+response.data[i].lastName
          if (response.data[i].clientData != null && response.data[i].clientData != '') {
            response.data[i].clientData = JSON.parse(response.data[i].clientData)
            if(response.data[i].clientData!=null && (response.data[i].clientData.genero=='' || response.data[i].clientData.genero==null)){
              response.data[i].clientData.genero='Masculino'
            }
          }else{
            response.data[i].clientData={}
            response.data[i].clientData.genero='Masculino'
          }
          this.users.push(response.data[i])
          this.clients.push(response.data[i])
        }
        this.users.sort((a, b) => (a.firstName > b.firstName) ? 1 : -1)
      })

      let search = ""
      if (this.$store.state.deviceUser == '' || this.$store.state.deviceUser == null) {
        search = this.$store.state.idUser
      } else {
        search = this.$store.state.deviceUser.login
      }
      this.$store.dispatch('getDevicesByUserLogin', search).then(response => {
        this.devices = []
        for (let i = 0; i < response.data.length; i++) {
          let object = JSON.parse(response.data[i].value)
          object.id = response.data[i].id
          object.selected = false
          object.user = response.data[i].user
          object.completeNameDevice = object.login + " - " + object.name

          this.devices.push(object)
        }
      })
    },

    openDialogPassword(item){
      this.cleanPasswordChange()
      this.editedIndex = this.users.indexOf(item)
      let userFromList = Object.assign({}, item)
      this.$store.dispatch('getOneUser', userFromList.login).then(response => {
          response.data.fullName = response.data.identification +" - "+response.data.firstName+" "+response.data.lastName
          if (response.data.clientData != null && response.data.clientData != '') {
            response.data.clientData = JSON.parse(response.data.clientData)
            if(response.data.clientData!=null && (response.data.clientData.genero=='' || response.data.clientData.genero==null)){
              response.data.clientData.genero='Masculino'
            }
          }else{
            response.data.clientData={}
            response.data.clientData.genero='Masculino'
          }
        this.user = response.data
        
        this.userRols = {id: this.user.authorities[0], name: "Administrador del Sistema"}
        if (this.user.clientData == null || this.user.clientData=={} || this.user.clientData=="") {
          this.user.clientData = {}
          this.user.clientData.devices=[]
          this.user.clientData.userChildren=[]
          this.user.clientData.genero='Masculino'
        }
        this.dialogPassword = true;
      })
    },
    changePassword () {
        this.$store.dispatch('changePasswordNotSession',  {key:this.user.login,newPassword:this.newPassword}).then(response => {
          this.cleanPasswordChange()
        }, error => {
          this.$store.dispatch('createDialogError', error)
        })
        this.dialogPassword = false
    },
    cleanPasswordChange() {
      this.newPassword = '';
      this.newPasswordConfirmation = '';
      this.dialogPassword = false;
      this.alert = false;
      this.valid = false;
    },
    getRoleName(name) {
      if (name == 'ROLE_ADMIN') {
        return 'Administrador del Sistema'
      } else if (name == 'ROLE_FLOTA') {
        return 'Administrador de Flota'
      } else if (name == 'ROLE_INSTALADOR') {
        return 'Instalador'
      } else if (name == 'ROLE_USER') {
        return 'Cliente'
      } else if (name == 'ROLE_CHOFER') {
        return 'Chofer'
      }
    },
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    addDevice(){
      let dev=this.device
      this.user.clientData.devices.push(dev)
    },
    deleteDevice(item){
      this.editedIndex = this.user.clientData.devices.indexOf(item)
      this.user.clientData.devices.splice(this.editedIndex,1)
    },
    addUserChildren(){
      let dev=this.userChild
      if(this.user.clientData.userChildren==null || this.user.clientData.userChildren=='' || typeof this.user.clientData.userChildren === 'undefined'){
        this.user.clientData.userChildren = []
      }
      this.user.clientData.userChildren.push(dev)
    },
    deleteUserChildren(item){
      this.editedIndex = this.user.clientData.userChildren.indexOf(item)
      this.user.clientData.userChildren.splice(this.editedIndex, 1)
    },

  },
  computed: {},
  created() {
    this.reloadData()
  },
 
}
</script>

<style scoped>
td {
  width: 50px;
}


</style>



// WEBPACK FOOTER //
// src/components/client/Client.vue